<template>
  <div>
    <v-btn @click="isShowDialog = true" 
    class="primary review-button" outlined color="white"> 
    {{ has_review ? trans('Edit Review') : trans('Add Review') }}
    </v-btn>
    <review-dialog
      @close="() => (isShowDialog = false)"
      v-if="isShowDialog"
      :activity="activity"
      :csrf="csrf"
    ></review-dialog>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
    has_review: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isShowDialog: false,
    }
  },
}
</script>

<style scoped>
.review-button {
  font-size: 0.9em;
}
</style>
